import { MetricCard, MetricCardsGrid } from "@/components/common/MetricCards";
import { useMemo } from "react";
import { ResourceName, Task, TaskStatus } from "@/types";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useGetList } from "react-admin";
import { TaskTab, getTasksBySelectedTab } from "../../utils/taskUtils";

interface TaskStatsProps {
  tab: TaskTab;
  validUserIds: string[];
}

export const TaskStats = ({ tab, validUserIds }: TaskStatsProps) => {
  const { data: allTasks = [] } = useGetList<Task>(ResourceName.TASKS, {
    pagination: { page: 1, perPage: 1000 },
    sort: { field: "due_date", order: "ASC" },
  });

  const tasks = getTasksBySelectedTab(allTasks, tab, validUserIds);

  const stats = useMemo(() => {
    let open = 0,
      inProgress = 0,
      completed = 0;

    for (const t of tasks) {
      switch (t.status) {
        case TaskStatus.OPEN:
          open++;
          break;
        case TaskStatus.IN_PROGRESS:
          inProgress++;
          break;
        case TaskStatus.COMPLETED:
          completed++;
          break;
        default:
          break;
      }
    }

    return { open, inProgress, completed };
  }, [tasks]);

  return (
    <MetricCardsGrid columns={3}>
      <MetricCard
        icon={<FolderOpenIcon sx={{ fontSize: 18, color: "primary.main" }} />}
        title="Open Tasks"
        value={stats.open}
      />
      <MetricCard
        icon={<PlayCircleOutlineIcon sx={{ fontSize: 18, color: "primary.main" }} />}
        title="In Progress Tasks"
        value={stats.inProgress}
      />
      <MetricCard
        icon={<CheckCircleOutlineIcon sx={{ fontSize: 18, color: "primary.main" }} />}
        title="Completed Tasks"
        value={stats.completed}
      />
    </MetricCardsGrid>
  );
};
